import { useWeb3State } from "@/web3/context";
import { Contract } from "ethers";
import { useMemo } from "react";
import { getChainContracts } from "@/shared/config/blockchain/helpers";
import IArtOrder from "./IArtOrder.json";

export default function useArtOrderContract() {
  const { signer, isCorrectChain, chainId } = useWeb3State();

  const contracts = getChainContracts(chainId);

  return useMemo(() => {
    if (!signer || !isCorrectChain || !contracts) return null;

    return new Contract(contracts.artOrderAddress, IArtOrder, signer);
  }, [signer, isCorrectChain, contracts]);
}
